import { createTheme, MantineColorsTuple } from '@mantine/core';

/**
 * Resource Centre visual language — warm teal primary, clean neutrals.
 * Matches the CCMS brand colour (#16A085) used in notification emails.
 */
const brand: MantineColorsTuple = [
  '#e6faf4',
  '#cdf0e5',
  '#9fe0ca',
  '#6dd0ae',
  '#46c296',
  '#30bb87',
  '#22b780',
  '#13a06d',
  '#008f5f',
  '#007b4e',
];

export const theme = createTheme({
  primaryColor: 'brand',
  colors: { brand },
  defaultRadius: 'md',
  headings: {
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: '700',
  },
});
